export const emailButtonLabel = "Eab";
export default {emailButtonLabel};